import React, { useEffect, useState } from 'react';
import { useDispatch } from 'react-redux';
import './liveTest.scss';
import LiveTestHeader from "./LiveTestHeader";
import LiveTestContent from "./LiveTestContent";
import { useScreenWidth, useTranslations } from "examsbook-react-sdk/custom-hooks";
import QuizCardButtons from "../QuizCard/QuizCardButtons";
import { toggleSavedQuiz } from "examsbook-react-sdk/actions";
import CardBgImg from "../../assets/images/quiz-card-test-img.png";

/**
 * Live test main card.
 * @param props
 * @returns {*}
 * @constructor
 */
function LiveTest(props) {
    const { testData } = props;
    const [ isMobile, setIfMobile ] = useState(false);
    const screenWidth = useScreenWidth();
    const dispatch = useDispatch();

    useEffect(() => {
        setIfMobile(screenWidth <= 488);
    }, [ screenWidth ]);
    const t = useTranslations();

    function unSaveQuiz(quiz) {
        dispatch(toggleSavedQuiz(quiz._id));
    }

    return (
        <div className="mock-test-card test-hover">
            <img src={CardBgImg} alt="" className="quiz-card-img"/>
            <LiveTestHeader testData={testData} toggleQuizSave={() => unSaveQuiz(testData)}/>
            <div className="inner-content">
                <LiveTestContent mobile={isMobile} testData={testData} t={t}/>
            </div>
            <QuizCardButtons quizData={testData} t={t}/>
        </div>
    );
}

export default LiveTest;
